import axios from '@/api/$axios'
export default {
  list ({ page, perPage }) {
    return axios.get(`/organizations`, {
      params: { page, perPage }
    })
  },
  data () {
    return axios.get(`/organization`)
  },
  byId ({ id }) {
    return axios.get(`/organizations/${id}`)
  }
}
